module.exports = __webpack_public_path__ + "static/media/jungala.257049e2.jpeg";